import React from 'react';

export const PriceComponent = React.memo(({ data }) => {
	const {
		retailPrice,
		pricePreMessage,
		pricePostMessage,
		productMinPrice,
    currencyCode
	} = data;

	const notNullCheck = (value) => {
		if (value <= 0 || value == '0' || value == '.00' || value == '0.00')
			return false;
		if (value) {
			return true;
		}
	};
	const decimalFormat = (amount) => {
		return Number(amount).toLocaleString(undefined, {
			minimumFractionDigits: 2,
			maximumFractionDigits: 2,
		});
	};

	const currencyCodeToDisplay = currencyCode === 'CAD' ? currencyCode : '';
	return (
		<span>
			<span className='fontSizeXS product-font-size'>
				{notNullCheck(pricePreMessage)  && (notNullCheck(productMinPrice) || notNullCheck(retailPrice))
					? pricePreMessage
					: null}
			</span>
			<b className='fontSize1X product-font-size ml-1'>
				{currencyCodeToDisplay}
				<span className='ml-1 product-price-font'>
					{notNullCheck(productMinPrice)
						? <>${decimalFormat(productMinPrice)} </>
						: notNullCheck(retailPrice)
						? <>${decimalFormat(retailPrice)} </> : null}
				</span>
			</b>
			{notNullCheck(pricePostMessage) && (
				<span className='fontSizeXS product-font-size ml-1'>
					{pricePostMessage}
				</span>
			)}
		</span>
	);
});
